import { ButtonRadio } from './button-radio.component';

/**
 * Used to emit changes performed on a `ButtonRadio`.
 */
export class ButtonRadioChange {
  /**
   * Contains the `ButtonRadio` that has been changed.
   */
  source: ButtonRadio | null;
  /**
   * The value of the `ButtonRadio` encompassed in the `ButtonRadioChange` class.
   */
  value: string;

  constructor(source: ButtonRadio, value: string) {
    this.source = source;
    this.value = value;
  }
}
